// Desert Storm — Single-Map variant.
// One phase only. Silo, Arsenal and Mercenary are all treated as flex zones
// from the start, so no player has to move when the Silo opens at 10:00.

import type { DSPlanConfig, DSPhaseDef, DSNonSiloSlot } from './dsTypes';
import {homeByRank, phases} from "@/plans/desertstorm.ts";

const meta = {
  key: 'desertstorm-one' as const,
  name: 'Desertstorm (Single Map)',
  shortDescription:
    'Simplified FoA planning model for Desert Storm using one board only. ' +
    'Silo, Arsenal and Mercenary are all marked as flex from the start — ' +
    'no player has to move once the Silo opens at 10:00.',
  integratedAt: '2026-07-01',
  rulebookRef: 'docs/plans/006-ds-plan.md',
  highlights: [
    'One board — no phase transitions.',
    'Silo, Arsenal and Mercenary are flex zones from the start (no movement at 10:00).',
    'Silo holds the top 2 by M1 (real Flex); Arsenal + Mercenary hold the next 2 by M1.',
    'Only FH II & FH IV are staffed. FH I & FH III stay empty — used only as spawn-dependent fallbacks (see tile notes).',
    'Substitutes inherit their starter\'s full route — no independent slots. Flex & Silo core never subbed.',
  ],
};

// Top 2 by M1 (non-flex) are still excluded from subs — they hold Arsenal
// and Mercenary as flex-analogue anchors.
const coreRanks = [0, 1] as const;

const slotNotes = {
  fieldHospital1: 'FH IV players relocate here if this tile is closer to our spawn.',
  fieldHospital2: 'Relocate to FH III if closer to our spawn.',
  fieldHospital3: 'FH II players relocate here if this tile is closer to our spawn.',
  fieldHospital4: 'Relocate to FH I if closer to our spawn.',
  arsenal: '',
  nuclearSilo: 'Flex',
  mercenary: '',
};

const onePhases = [{
  ...phases[1],
  title: 'BATTLE PLAN',
  time: '0:00 – END',
  timeColor: 'text-orange-400',
  subtitle: '',
  subtitleColor: 'text-orange-400',
}]

export const desertstormOneConfig: DSPlanConfig = {
  meta,
  phases: onePhases,
  homeByRank,
  coreRanks,
  slotNotes,
  flexSlots: ['nuclearSilo'],
};
